import { lazy } from "react";

export const VoucherDetailsAsync = lazy(() => import("./VoucherDetails"));
